export const LOGIN_INITIAL_VALUES = {
    username: '',
    password: '',
};

export const LOGIN_ERROR_MESSAGES = {
    INVALID_CREDENTIALS: "Invalid Username or Password",
    SERVER_ERROR: "Server error occurred",
    MATRIX_AUTH_WARNING: "Warning: Chat functionality may not be available due to synapse authentication issues",
    MATRIX_MISSING_WARNING: "Warning: Chat functionality not available - missing synapse credentials"
};

export const APPOINTMENT_CHECK_INTERVAL = 30000;
export const MATRIX_NOTIFICATION_INTERVAL = 30000;
